import { useContext, useEffect, useRef, useState } from "react";
import { Link, useParams } from "react-router-dom";
import pathObj from "../../services/Config";
import { CommonService } from "../../services/common";
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { checkImage, decryptData, errorHandling, UpdatedDecimalDigits } from "../../helpers/common";
import { formatPriceWithBreakdown } from "../../helpers/priceHelper";
import AlternativeRelativeProducts from "./AlternativeRelativeProducts";
import { CartContext } from "../../context/cartContext";
import toast from "react-hot-toast";
import { Helmet } from "react-helmet";
import getSymbolFromCurrency from "currency-symbol-map";
import Zoom from 'react-medium-image-zoom'
import 'react-medium-image-zoom/dist/styles.css'
const ProductDetails = () => {
  const { itemCode } = useParams();
  const ItemId = itemCode
  const [productDetails, setProductDetails] = useState([]);
  const [attributesListDetails, setAttributesListDetails] = useState([]);
  const [quantities, setQuantities] = useState({});
  const hasFetched = useRef(false);
  const userInfo = window.localStorage.getItem('userData')
  const userD = decryptData(userInfo)
  const compData = JSON.parse(userD)
  const currencyName = compData?.Currency
  const currencySymbol = getSymbolFromCurrency(currencyName);
  const customerId = compData?.customer_id;
  const [priceBreakDown, setPriceBreakDown] = useState('');
  const { addToCartCount } = useContext(CartContext);
  const [priceDropdownVisible, setPriceDropdownVisible] = useState({});
  const category = localStorage.getItem('categoriesName')
  const productType = localStorage.getItem('productType')
  const token = localStorage.getItem("Token");
  const [wishlistStatus, setWishlistStatus] = useState({});
  const [imageStatus, setImageStatus] = useState({});
  const [selectedPriceBreakdown, setSelectedPriceBreakdown] = useState({});
  const [zoom, setZoom] = useState({ display: 'none', backgroundPosition: 'center', backgroundImage: '' });
  const [imageDimensions, setImageDimensions] = useState({ width: 0, height: 0 });
  const [activeImage, setActiveImage] = useState('');
  const [originalActiveImage, setOriginalActiveImage] = useState(''); // Track the current slide image
  const [loading, setLoading] = useState(true);
  const [breadcrumbSlugs, setBreadcrumbSlugs] = useState([]);
  const [zoomBox, setZoomBox] = useState({ display: 'none', left: 0, top: 0 });
  const [magnifier, setMagnifier] = useState({ display: 'none', left: 0, top: 0 });
  const [showModal, setShowModal] = useState(false);
  const [modalImage, setModalImage] = useState('');
  const [modalImageIndex, setModalImageIndex] = useState(0);
  const [allModalImages, setAllModalImages] = useState([]);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [lastHoverTime, setLastHoverTime] = useState(0); // Add throttling for hover events
  const productFilter = localStorage.getItem("productFilterString");

  // Decode the URL-encoded string
  const decodedFilter = decodeURIComponent(productFilter);
  // Split the string by '|'
  const categories = decodedFilter.split('|');
  // Assign each category to a variable
  const formattedCategory = categories[0]; // MPL/UPVC
  const formattedSubCategory = categories[1]; // Door Hardware
  const formattedChild = categories[2]; // Door Keeps


  const payTermsGrp = compData?.PayTermsGrpCode;

  const [categoryName = '', subCategoryName = '', childName = ''] = (productFilter || '').split('|');

  // const formattedCategory = categoryName.replace(/\s+/g, '-').replace(/[()]/g, '').toLowerCase();
  // const formattedSubCategory = subCategoryName.replace(/\s+/g, '-').replace(/[()]/g, '').toLowerCase();
  // const formattedChild = childName.replace(/\s+/g, '-');

  const imageContainerRef = useRef(null);
  const magnifierHeight = 500; // Height of the magnifier box
  const magnifierWidth = 850; // Width of the magnifier box (double the height)
  const zoomLevel = 4; // Zoom magnification level
  // Calculate zoom box size based on magnifier dimensions and zoom level
  const zoomBoxWidth = magnifierWidth / zoomLevel; // Width of zoom box
  const zoomBoxHeight = magnifierHeight / zoomLevel; // Height of zoom box
  
  // Mouse move handler for the zoom effect
  const handleMouseMove = (e) => {
    if (!activeImage) return; // Ensure an image is selected
    
    // Get the actual image element inside the slider
    const sliderElement = imageContainerRef.current.querySelector('.slick-active img');
    if (!sliderElement) return;
    
    const { left, top, width, height } = sliderElement.getBoundingClientRect();
    const x = e.clientX - left;
    const y = e.clientY - top;
    
    // Only show zoom if mouse is within image bounds
    if (x < 0 || y < 0 || x > width || y > height) {
      setZoomBox({ display: 'none', left: 0, top: 0 });
      setMagnifier({ display: 'none', left: 0, top: 0 });
      return;
    }
    
    // Calculate zoom box position (small box that follows cursor)
    const containerRect = imageContainerRef.current.getBoundingClientRect();
    const relativeX = e.clientX - containerRect.left;
    const relativeY = e.clientY - containerRect.top;
    
    const zoomBoxLeft = Math.max(0, Math.min(relativeX - zoomBoxWidth / 2, containerRect.width - zoomBoxWidth));
    const zoomBoxTop = Math.max(0, Math.min(relativeY - zoomBoxHeight / 2, containerRect.height - zoomBoxHeight));
    
    // Calculate magnifier position (large box showing zoomed image) - Smart positioning
    const viewportWidth = window.innerWidth;
    const containerLeft = containerRect.left;
    
    // Check if there's enough space on the left for the magnifier
    const spaceOnLeft = containerLeft;
    const spaceOnRight = viewportWidth - (containerLeft + containerRect.width);
    
    let magnifierLeft;
    if (spaceOnLeft >= magnifierWidth + 20 && spaceOnLeft > spaceOnRight) {
      // Position to the left if there's space
      magnifierLeft = -magnifierWidth - 20;
    } else {
      // Position to the right as fallback
      magnifierLeft = containerRect.width + 20;
    }
    const magnifierTop = 0;
    
    // Calculate background position based on actual image position, not container
    // Get the exact position relative to the actual image
    const imageRect = sliderElement.getBoundingClientRect();
    const imageX = x;  // x is already relative to image
    const imageY = y;  // y is already relative to image
    
    // Calculate the exact position within the image as percentage
    const bgPosX = (imageX / imageRect.width) * 100;
    const bgPosY = (imageY / imageRect.height) * 100;

    setZoomBox({
      display: 'block',
      left: zoomBoxLeft,
      top: zoomBoxTop,
    });
    
    // Calculate proper background size to show exact zoomed area
    const bgWidth = imageRect.width * zoomLevel;
    const bgHeight = imageRect.height * zoomLevel;

    setMagnifier({
      display: 'block',
      left: magnifierLeft,
      top: magnifierTop,
      backgroundImage: `url(${activeImage})`,
      backgroundPosition: `${bgPosX}% ${bgPosY}%`,
      backgroundSize: `cover`,
    });
    
    setImageDimensions({ width, height });
  };

  // Handle window resize for responsive design
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Initial active image load when product details are fetched
  useEffect(() => {
    if (imageStatus['Picture'] && imageStatus['Picture'].length > 0) {
      // Set first Picture as active (Picture comes first in slider order)
      const firstImage = imageStatus['Picture'][0];
      setActiveImage(firstImage);
      setOriginalActiveImage(firstImage); // Also set as original
      
      // Ensure slider goes to first slide
      if (sliderContentRef.current) {
        sliderContentRef.current.slickGoTo(0);
      }
    } else if (imageStatus['vectorPicture']) {
      setActiveImage(imageStatus['vectorPicture']);
      setOriginalActiveImage(imageStatus['vectorPicture']); // Also set as original
      
      // If only vectorPicture, go to that slide
      if (sliderContentRef.current) {
        sliderContentRef.current.slickGoTo(0);
      }
    }
  }, [imageStatus]);

  // Reset current slide to 0 when images load
  useEffect(() => {
    if ((imageStatus['Picture'] && imageStatus['Picture'].length > 0) || imageStatus['vectorPicture']) {
      setCurrentSlide(0);
    }
  }, [imageStatus]);

  // Mouse leave handler to remove zoom effect
  const handleMouseLeave = () => {
    setZoom({ display: 'none', backgroundPosition: 'center', backgroundImage: '' });
    setZoomBox({ display: 'none', left: 0, top: 0 });
    setMagnifier({ display: 'none', left: 0, top: 0 });
  };

  // Handle image click to open modal
  const handleImageClick = (imageSrc) => {
    // Build array of all images in the same order as they appear in the slider
    const allImages = [];
    if (imageStatus['Picture'] && imageStatus['Picture'].length > 0) {
      allImages.push(...imageStatus['Picture']);
    }
    if (imageStatus['vectorPicture']) {
      allImages.push(imageStatus['vectorPicture']);
    }
    
    setAllModalImages(allImages);
    const clickedIndex = allImages.findIndex(img => img === imageSrc);
    setModalImageIndex(clickedIndex >= 0 ? clickedIndex : 0);
    setModalImage(imageSrc);
    setShowModal(true);
  };

  // Handle modal close
  const handleModalClose = () => {
    setShowModal(false);
    setModalImage('');
    setModalImageIndex(0);
    setAllModalImages([]);
  };

  // Handle modal navigation
  const handleModalPrevious = () => {
    const newIndex = modalImageIndex > 0 ? modalImageIndex - 1 : allModalImages.length - 1;
    setModalImageIndex(newIndex);
    setModalImage(allModalImages[newIndex]);
  };

  const handleModalNext = () => {
    const newIndex = modalImageIndex < allModalImages.length - 1 ? modalImageIndex + 1 : 0;
    setModalImageIndex(newIndex);
    setModalImage(allModalImages[newIndex]);
  };

  // Handle keyboard navigation
  const handleModalKeyPress = (e) => {
    if (e.key === 'ArrowLeft') {
      handleModalPrevious();
    } else if (e.key === 'ArrowRight') {
      handleModalNext();
    } else if (e.key === 'Escape') {
      handleModalClose();
    }
  };

  const fetchProductDetails = async () => {
    setLoading(true);
    try {
      const Currency = compData?.Currency;
      const PriceListNum = compData?.PriceListNum;
      const customer_id = customerId;
      const url = `${pathObj.baseURL}${pathObj.getProductDetails}?ItemCode=${ItemId}`;
      const payload = {
        Currency,
        PriceListNum,
        customer_id,
        category,
        productType,
      };
      const data = await CommonService.getAllWithBodyWithToken(url, payload);
      localStorage.setItem('productFilterString', data?.data?.productFilterString)
      setProductDetails(data?.data);
      setBreadcrumbSlugs(data?.data?.productFilterSlug?.split('/'))
      setAttributesListDetails(Object.entries(data?.data?.AttributesList || []));
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Error fetching page data:", error);
      errorHandling(error);
    }
  };


  useEffect(() => {
    if (!hasFetched.current) {
      fetchProductDetails();
      hasFetched.current = true;
    }
  }, [itemCode]);

  const [currentPrice, setCurrentPrice] = useState(0);
  const [priceBreakDownId, setPriceBreakDownId] = useState(0);
  const handleQuantityChange = (itemCode, type, customQuantity = null) => {
    setQuantities((prevQuantities) => {
      const newQuantities = { ...prevQuantities };
      let currentQuantity = newQuantities[itemCode] || 1;

      if (customQuantity !== null) {
        currentQuantity = parseInt(customQuantity, 10);
        if (isNaN(currentQuantity) || currentQuantity < 1) {
          currentQuantity = 1; // Ensure quantity is always at least 1
        }
      } else if (type === "plus") {
        currentQuantity += 1;
      } else if (type === "minus" && currentQuantity > 1) {
        currentQuantity -= 1;
      }

      newQuantities[itemCode] = currentQuantity;

      // New logic to update price based on quantity
      const priceBreaks = productDetails?.PricesBreakdown || []; // Use the correct source for price breaks
      let newPrice = 0;
      let newPriceBreakDownId = null; // Declare the variable here

      for (let i = 0; i < priceBreaks.length; i++) {
        if (currentQuantity >= priceBreaks[i].Quantity) {
          newPrice = priceBreaks[i].SpecialPrice;
          newPriceBreakDownId = priceBreaks[i].id; // Use the correct ID
        } else {
          break; // Stop checking once we find a price break that doesn't apply
        }
      }

      // Update the state with the new price
      setCurrentPrice(newPrice); // Update the current price
      setPriceBreakDownId(newPriceBreakDownId); // Update the price breakdown ID

      setPriceDropdownVisible((prevVisible) => ({
        ...prevVisible,
        [itemCode]: currentQuantity > 1,
      }));

      return newQuantities;
    });
  };

  // Ensure handlePriceBreakdownClick updates selectedPriceBreakdown correctly



  // New function to handle the toggle of priceDropdownVisible
  const togglePriceDropdown = (itemCode) => {
    if (!priceDropdownVisible[itemCode]) {
      setPriceDropdownVisible((prevVisible) => ({
        ...prevVisible,
        [itemCode]: !prevVisible[itemCode],
      }));
    }
  };

  const handlePriceBreakdownClick = (itemCode, quantity, priceBreakDownId, price) => {
    setPriceBreakDown(priceBreakDownId);
    setSelectedPriceBreakdown((prevBreakdowns) => ({
      ...prevBreakdowns,
      [itemCode]: {
        quantity, // Set the quantity from the breakdown
        price, // Use the passed price
        priceBreakDownId, // Set the price breakdown ID
      },
    }));
    handleQuantityChange(itemCode, null, quantity); // Call to update quantity and price
  };


  const handleAddToCart = async (product) => {
    if (product?.QuantityOnStock > 0 || (product?.QuantityOnStock <= 0 && payTermsGrp != 17)) {
      const quantity = quantities[product?.ItemCode] || 1;

      // Use the selected price breakdown for this product, if available
      const selectedBreakdown = selectedPriceBreakdown[product?.ItemCode] || {};
      // const priceBDownIdToUse = selectedBreakdown.priceBreakDownId || priceBreakDown; // Fallback to general breakdown if needed

      const product_price_id = product?.ProductPrice?.[0]?.id ? product?.ProductPrice?.[0]?.id : '';

      const url = `${pathObj.baseURL}${pathObj.addCart}`;
      const payload = {
        customer_id: customerId,
        product_id: product?.id,
        quantity: quantity, // Use the selected quantity
        price_break_down_id: priceBreakDownId ? priceBreakDownId : '', // Send the selected breakdown ID
        product_price_id,
        Csprice: selectedBreakdown.price ? selectedBreakdown.price : product?.Csprice > 0 ? product?.Csprice : 0,
        price: selectedBreakdown.price ? selectedBreakdown.price : product?.Csprice > 0 ? 0 : product?.MainProductPrice || currentPrice,
        product_itemcode: product?.ItemCode,
        customer_cardcode: compData?.CardCode,
      };

      try {
        const response = await CommonService.getAllWithBodyWithToken(url, payload);
        if (response.success) {
          toast.success(response.message || `${product?.ItemCode} added to cart successfully.!`);
          addToCartCount(product);
        } else {
          toast.error(response.message || "Something went wrong!");
        }
      } catch (error) {
        console.error("Error adding product to cart:", error);
        errorHandling(error);
      }
    } else {
      toast.error("Item Currently not available!");
    }
  };


  const CustomNextArrow = ({ onClick, disabled }) => {
    return (
      <button
        type="button"
        data-role="none"
        className="slick-next slick-arrow"
        aria-label="Next"
        role="button"
        style={{ display: "block", opacity: disabled ? 0 : 1 }}
        onClick={!disabled ? onClick : null}
        disabled={disabled} // Disable the button
      >
        Next
      </button>
    );
  };

  const CustomPrevArrow = ({ onClick, disabled }) => {
    return (
      <button
        type="button"
        data-role="none"
        className="slick-prev slick-arrow"
        aria-label="Previous"
        role="button"
        style={{ display: "block", opacity: disabled ? 0 : 1 }}
        onClick={!disabled ? onClick : null}
        disabled={disabled} // Disable the button
      >
        Previous
      </button>
    );
  };
  const [currentSlide, setCurrentSlide] = useState(0);
  const sliderContentRef = useRef(null);
  const sliderThumbRef = useRef(null);
  const contentSlidesCount = imageStatus['Picture']?.length + (imageStatus['vectorPicture'] ? 1 : 0 ) || 2; // Adjust this to your total slide count

  const contentSettings = {
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: imageStatus['Picture'] || imageStatus['vectorPicture'] ? true : false,
    infinite: false,
    speed: 1000,
    initialSlide: 0,
    asNavFor: sliderThumbRef.current,
    ref: sliderContentRef,
    nextArrow: (
      <CustomNextArrow disabled={currentSlide === contentSlidesCount - 1} />
    ),
    prevArrow: <CustomPrevArrow disabled={currentSlide === 0} />,
    beforeChange: (oldIndex, newIndex) => {
      setCurrentSlide(newIndex);
      
      // Determine the correct image for the new slide based on the actual slide order
      let image;
      
      // Build array of all images in the same order as they appear in the slider
      const allImages = [];
      if (imageStatus['Picture'] && imageStatus['Picture'].length > 0) {
        allImages.push(...imageStatus['Picture']);
      }
      if (imageStatus['vectorPicture']) {
        allImages.push(imageStatus['vectorPicture']);
      }
      
      // Set the active image based on the slide index
      if (allImages[newIndex]) {
        image = allImages[newIndex];
      }
      
      setActiveImage(image); // Set the correct image for zoom based on the active slide
      setOriginalActiveImage(image); // Also track as original image
    },
  };
  let totalProdImages = imageStatus['Picture']?.length + (imageStatus['vectorPicture'] ? 1 : 0);


  const handleRatingChange = async (itemCode, rating) => {
    
    if (rating && itemCode) {
      const url = `${pathObj.baseURL}/saveRating`; // Update with your API endpoint
      const payload = {
        product_id: itemCode,
        customer_id: customerId,
        rating: rating,
      };
      try {
        const response = await CommonService.getAllWithBodyWithToken(url, payload);
        if (response.success) {
          toast.success(response?.message || "Rating submitted successfully!");
          setTimeout(() => {
            fetchProductDetails();
          }, 300);
        } else {
          toast.error(response.message || "Failed to submit rating.");
        }
      } catch (error) {
        console.error("Error submitting rating:", error);
      }
    };
  }

  const handleWishlistToggle = async (productItemCode) => {
    const currentStatus = wishlistStatus[productItemCode] || false; // Get current status of the product
    const url = `${pathObj.baseURL}/saveFavoriteItem`; // Update with your API endpoint
    const payload = {
      customer_id: customerId,
      product_id: productItemCode,
      status: currentStatus ? 0 : 1, // Toggle wishlist status
    };

    try {
      const response = await CommonService.getAllWithBodyWithToken(url, payload);
      if (response.success) {
        // Update the wishlist status for the specific product
        setWishlistStatus((prevStatus) => ({
          ...prevStatus,
          [productItemCode]: !currentStatus, // Toggle the wishlist status
        }));
        toast.success(response?.message || "Wishlist updated successfully!");
        setTimeout(() => {
          fetchProductDetails();
        }, 300);
      } else {
        toast.error(response.message || "Failed to update wishlist.");
      }
    } catch (error) {
      console.error("Error updating wishlist:", error);
      toast.error("An error occurred while updating the wishlist.");
      errorHandling(error);
    }
  };

  // Ensure the image loading function sets up the correct status for each image
  const loadImages = async () => {
    const status = {};

    if (productDetails?.vectorPicture) {
      const vectorPictureCheck = await checkImage(productDetails.vectorPicture);
      status['vectorPicture'] = vectorPictureCheck?.status === 'ok' ? productDetails.vectorPicture : '';
    }

    if (productDetails?.Picture) {
      const pictureUrls = productDetails.Picture.split(',').map(url =>
        checkImage(url.trim())
      );

      const results = await Promise.allSettled(pictureUrls);
      const validPictures = results.reduce((acc, result) => {
        if (result.status === 'fulfilled' && result.value?.status === 'ok') {
          if (result.value?.path) {
            acc.push(result.value?.path);
          }
        }
        return acc;
      }, []);
      
      if (validPictures.length > 0) {
        status['Picture'] = validPictures;
      }else if(validPictures.length == 0 && !status['vectorPicture'] ){
        status['Picture'] = [`${pathObj?.s3ImagePath}/no-image.jpg`];
      }
    }

    

    setImageStatus(status);
  };

  useEffect(() => {
    if (productDetails?.length > 0 || productDetails) {
      loadImages();
    }
  }, [productDetails]);

  // useEffect(() => {
  //   if (productDetails) {
  //     loadImages();
  //   }
  // }, [productDetails]);

  const productDescription =
    `${productDetails?.U_V33_WebDescription || ''} ${productDetails?.U_V33_WebDescription2 || ''} ${productDetails?.U_V33_WebDescription3 || ''}`.trim();

  return (
    <>
      <Helmet>
        <title>
          {productDetails?.U_V33_WebProductName || "Default Product Name"} | Davenport Burgess
        </title>
        <meta
          name="description"
          content={`Product description - ${productDetails?.U_V33_WebDescription || "Default description"}`}
        />
      </Helmet>
      {loading ? (
        <div className="loader"></div>
      ) : (
        <>
          <div className="pd_wrap">

            <div className="container">

              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <a href="#">
                      <img src={`${pathObj?.s3ImagePath}/home-icon.svg`} alt="" />
                    </a>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to={`/categories/${breadcrumbSlugs[0]}`}>
                      {formattedCategory}
                    </Link>
                  </li>

                  {formattedSubCategory && breadcrumbSlugs[1] && breadcrumbSlugs[2] && <li className="breadcrumb-item" aria-current="page">
                    <Link to={`/categories/${breadcrumbSlugs[0]}/${breadcrumbSlugs[1]}`}>
                      {formattedSubCategory}
                    </Link>
                  </li>
                  }

                  {formattedSubCategory && breadcrumbSlugs[1] && !breadcrumbSlugs[2] && <li className="breadcrumb-item" aria-current="page">
                    {formattedSubCategory}
                  </li>
                  }

                  {formattedChild && breadcrumbSlugs[2] && <li className="breadcrumb-item active" aria-current="page">
                    {formattedChild}
                  </li>
                  }
                </ol>
              </nav>

              <div className="clinner">

                <div className="d-flex flex-wrap">

                {!imageStatus['Picture'] && !imageStatus['vectorPicture'] ? (
                    <div className="loader"></div>
                  ) : (
                  <div className="pdLeft">
                    <div className="product-images-container" style={{ 
                      display: 'flex', 
                      gap: isMobile ? '10px' : '15px',
                      alignItems: 'flex-start',
                      flexDirection: isMobile ? 'column' : 'row',
                      position: 'relative', // Ensure positioning context
                      width: '100%', // Ensure full width
                      maxWidth: '100%', // Prevent overflow
                      overflow: 'visible' // Allow magnifier to show
                    }}>
                      {/* Thumbnail Slider - Left Side */}
                      <div className="thumbnail-section" style={{ 
                        width: isMobile ? '100%' : '100px', // Increased from 90px to 100px for better visibility
                        minWidth: isMobile ? 'auto' : '100px', // Ensure minimum width
                        maxHeight: isMobile ? '100px' : '500px',
                        overflowY: isMobile ? 'hidden' : 'auto',
                        overflowX: isMobile ? 'auto' : 'hidden',
                        order: isMobile ? 2 : 1,
                        flexShrink: 0 // Prevent shrinking
                      }}>
                        <div className="thumbnail-wrapper" style={{
                          display: 'flex',
                          flexDirection: isMobile ? 'row' : 'column',
                          gap: isMobile ? '8px' : '10px',
                          paddingBottom: isMobile ? '10px' : '0'
                        }}>
                          {/* Render Picture thumbnails */}
                          {imageStatus['Picture'] && imageStatus['Picture'].length > 0 && imageStatus['Picture'].map((picture, index) => (
                            <div 
                              key={index}
                              className="thumbnail-item"
                              style={{
                                width: isMobile ? '60px' : '90px', // Increased from 80px to 90px for better visibility
                                height: isMobile ? '60px' : '90px',
                                minWidth: isMobile ? '60px' : '90px',
                                border: activeImage === picture ? '2px solid #FEB41D' : '2px solid #e0e0e0',
                                borderRadius: '6px',
                                overflow: 'hidden',
                                cursor: 'pointer',
                                transition: 'border-color 0.3s ease',
                                backgroundColor: '#fff', // Ensure background visibility
                                boxShadow: '0 2px 4px rgba(0,0,0,0.1)' // Add subtle shadow for definition
                              }}
                              onClick={() => {
                                // Handle thumbnail click to change main image
                                setActiveImage(picture);
                                const allImages = [];
                                if (imageStatus['Picture'] && imageStatus['Picture'].length > 0) {
                                  allImages.push(...imageStatus['Picture']);
                                }
                                if (imageStatus['vectorPicture']) {
                                  allImages.push(imageStatus['vectorPicture']);
                                }
                                const clickedIndex = allImages.findIndex(img => img === picture);
                                if (sliderContentRef.current) {
                                  sliderContentRef.current.slickGoTo(clickedIndex);
                                }
                              }}
                              onMouseEnter={(e) => {
                                if (!isMobile) {
                                  // Throttle rapid hover events (minimum 100ms between changes)
                                  const now = Date.now();
                                  if (now - lastHoverTime < 100) return;
                                  setLastHoverTime(now);
                                  
                                  // Execute same functionality as onClick - change main slide
                                  const allImages = [];
                                  if (imageStatus['Picture'] && imageStatus['Picture'].length > 0) {
                                    allImages.push(...imageStatus['Picture']);
                                  }
                                  if (imageStatus['vectorPicture']) {
                                    allImages.push(imageStatus['vectorPicture']);
                                  }
                                  const clickedIndex = allImages.findIndex(img => img === picture);
                                  
                                  // Only proceed if we have a valid index and slider ref
                                  if (clickedIndex >= 0 && sliderContentRef.current && sliderContentRef.current.slickGoTo) {
                                    // Set active image first
                                    setActiveImage(picture);
                                    // Add small delay to ensure state updates
                                    setTimeout(() => {
                                      if (sliderContentRef.current && sliderContentRef.current.slickGoTo) {
                                        sliderContentRef.current.slickGoTo(clickedIndex);
                                      }
                                    }, 10);
                                  }
                                }
                                // Always update border color on hover
                                e.target.style.borderColor = '#FEB41D';
                              }}
                              onMouseLeave={(e) => {
                                // Just handle border color since slide change is now permanent
                                e.target.style.borderColor = activeImage === picture ? '#FEB41D' : '#e0e0e0';
                              }}
                            >
                              <img
                                src={picture}
                                alt={`Thumbnail ${index + 1}`}
                                style={{
                                  width: '100%',
                                  height: '100%',
                                  objectFit: 'cover'
                                }}
                                onError={(e) => {
                                  e.target.onerror = null;
                                  e.target.src = `${pathObj?.s3ImagePath}/no-image.jpg`;
                                }}
                              />
                            </div>
                          ))}

                          {/* Render vectorPicture thumbnail */}
                          {imageStatus['vectorPicture'] && (
                            <div 
                              className="thumbnail-item"
                              style={{
                                width: isMobile ? '60px' : '90px', // Increased from 80px to 90px for better visibility
                                height: isMobile ? '60px' : '90px',
                                minWidth: isMobile ? '60px' : '90px',
                                border: activeImage === imageStatus['vectorPicture'] ? '2px solid #FEB41D' : '2px solid #e0e0e0',
                                borderRadius: '6px',
                                overflow: 'hidden',
                                cursor: 'pointer',
                                transition: 'border-color 0.3s ease',
                                backgroundColor: '#fff', // Ensure background visibility
                                boxShadow: '0 2px 4px rgba(0,0,0,0.1)' // Add subtle shadow for definition
                              }}
                              onClick={() => {
                                setActiveImage(imageStatus['vectorPicture']);
                                const allImages = [];
                                if (imageStatus['Picture'] && imageStatus['Picture'].length > 0) {
                                  allImages.push(...imageStatus['Picture']);
                                }
                                if (imageStatus['vectorPicture']) {
                                  allImages.push(imageStatus['vectorPicture']);
                                }
                                const clickedIndex = allImages.findIndex(img => img === imageStatus['vectorPicture']);
                                if (sliderContentRef.current) {
                                  sliderContentRef.current.slickGoTo(clickedIndex);
                                }
                              }}
                              onMouseEnter={(e) => {
                                if (!isMobile) {
                                  // Throttle rapid hover events (minimum 100ms between changes)
                                  const now = Date.now();
                                  if (now - lastHoverTime < 100) return;
                                  setLastHoverTime(now);
                                  
                                  // Execute same functionality as onClick - change main slide
                                  const allImages = [];
                                  if (imageStatus['Picture'] && imageStatus['Picture'].length > 0) {
                                    allImages.push(...imageStatus['Picture']);
                                  }
                                  if (imageStatus['vectorPicture']) {
                                    allImages.push(imageStatus['vectorPicture']);
                                  }
                                  const clickedIndex = allImages.findIndex(img => img === imageStatus['vectorPicture']);
                                  
                                  // Only proceed if we have a valid index and slider ref
                                  if (clickedIndex >= 0 && sliderContentRef.current && sliderContentRef.current.slickGoTo) {
                                    // Set active image first
                                    setActiveImage(imageStatus['vectorPicture']);
                                    // Add small delay to ensure state updates
                                    setTimeout(() => {
                                      if (sliderContentRef.current && sliderContentRef.current.slickGoTo) {
                                        sliderContentRef.current.slickGoTo(clickedIndex);
                                      }
                                    }, 10);
                                  }
                                }
                                // Always update border color on hover
                                e.target.style.borderColor = '#FEB41D';
                              }}
                              onMouseLeave={(e) => {
                                // Just handle border color since slide change is now permanent
                                e.target.style.borderColor = activeImage === imageStatus['vectorPicture'] ? '#FEB41D' : '#e0e0e0';
                              }}
                            >
                              <img
                                src={imageStatus['vectorPicture']}
                                alt="Vector thumbnail"
                                style={{
                                  width: '100%',
                                  height: '100%',
                                  objectFit: 'cover'
                                }}
                                onError={(e) => {
                                  e.target.onerror = null;
                                  e.target.src = `${pathObj?.s3ImagePath}/no-image.jpg`;
                                }}
                              />
                            </div>
                          )}
                        </div>
                      </div>

                      {/* Main Image Container - Right Side */}
                      <div
                        className="slider-container"
                        ref={imageContainerRef}
                        onMouseMove={!isMobile ? handleMouseMove : undefined}
                        onMouseLeave={!isMobile ? handleMouseLeave : undefined}
                        onMouseEnter={!isMobile ? () => {/* Ensure zoom is ready when mouse enters */} : undefined}
                        style={{ 
                          position: "relative", 
                          overflow: "visible",
                          flex: 1,
                          minHeight: isMobile ? "250px" : "500px",
                          maxWidth: isMobile ? "100%" : "690px", // Reduced from 800px to 690px to accommodate thumbnails
                          width: "100%",
                          order: isMobile ? 1 : 2,
                          // border: "2px solid #e0e0e0", // Added border
                          borderRadius: "8px", // Rounded corners
                          // padding: "10px", // Inner padding
                          // backgroundColor: "#fafafa" // Light background
                        }}
                      >
                      <Slider {...contentSettings} className="slider slider-content slick-initialized slick-slider">
                        {/* Render the Picture image if its status is "ok" */}
                        {imageStatus['Picture'] && imageStatus['Picture'].length > 0 && imageStatus['Picture'].map((picture, index) => (
                          <div className="slick-slider-item" key={index}>
                            <div 
                              style={{ 
                                position: 'relative', 
                                width: '100%', 
                                height: '100%',
                                display: 'block'
                              }}
                            >
                              <img
                                src={picture}
                                alt=""
                                onError={(e) => {
                                  e.target.onerror = null;
                                  e.target.src = `${pathObj?.s3ImagePath}/no-image.jpg`;
                                }}
                                onClick={() => handleImageClick(picture)}
                                style={{ 
                                  width: '100%', 
                                  maxHeight: '500px', 
                                  objectFit: 'contain', 
                                  cursor: 'zoom-in',
                                  display: 'block'
                                }}
                              />
                            </div>
                          </div>
                        ))}

                        {/* Render the vectorPicture image if its status is "ok" */}
                        {imageStatus['vectorPicture'] ? (
                          <div className="slick-slider-item">
                            <div 
                              style={{ 
                                position: 'relative', 
                                width: '100%', 
                                height: '100%',
                                display: 'block'
                              }}
                            >
                              <img
                                src={imageStatus['vectorPicture']}
                                alt=""
                                onError={(e) => {
                                  e.target.onerror = null;
                                  e.target.src = `${pathObj?.s3ImagePath}/no-image.jpg`;
                                }}
                                onClick={() => handleImageClick(imageStatus['vectorPicture'])}
                                style={{ 
                                  width: '100%', 
                                  maxHeight: '500px', 
                                  objectFit: 'contain', 
                                  cursor: 'zoom-in',
                                  display: 'block'
                                }}
                              />
                            </div>
                          </div>
                        ) : null}

                      </Slider>


                      {/* Zoom Box - Small box that follows cursor */}
                      <div
                        className="zoom-box"
                        style={{
                          display: zoomBox.display,
                          position: "absolute",
                          left: zoomBox.left,
                          top: zoomBox.top,
                          width: zoomBoxWidth,
                          height: zoomBoxHeight,
                          border: '2px solid #FEB41D',
                          backgroundColor: 'rgba(254, 180, 29, 0.3)',
                          pointerEvents: "none",
                          zIndex: 10,
                        }}
                      />
                      
                      {/* Magnifier Box - Large box showing zoomed image */}
                      <div
                        className="magnifier-box"
                        style={{
                          display: magnifier.display,
                          position: "absolute",
                          left: magnifier.left,
                          top: magnifier.top,
                          width: magnifierWidth,
                          height: magnifierHeight,
                          border: '2px solid #FEB41D',
                          borderRadius: '8px',
                          backgroundImage: magnifier.backgroundImage,
                          backgroundPosition: magnifier.backgroundPosition,
                          backgroundSize: magnifier.backgroundSize,
                          backgroundRepeat: "no-repeat",
                          pointerEvents: "none",
                          zIndex: 15,
                          boxShadow: '0 4px 15px rgba(0,0,0,0.3)',
                          overflow: 'hidden',
                        }}
                      />
                    </div>
                    </div>
                  </div>
                )}

                  <div className="pdRight">

                    <h1>{productDetails?.ItemCode} - {productDetails?.U_V33_WebProductName}</h1>

                    <div className="instock_row">
                      {productDetails?.QuantityOnStock ? (
                        <div className="instock">
                          <img
                            src={`${pathObj?.s3ImagePath}/instock-icon.svg`}
                            alt="In Stock"
                          />{" "}
                          In Stock
                        </div>
                      ) : (
                        <div className="outofstock">
                          <img
                            src={`${pathObj?.s3ImagePath}/out-stock.svg`}
                            alt="Currently not available"
                          />{" "}
                          Currently not available
                        </div>
                      )}
                      {token && (
                        <div className="wishlist">
                          <img
                            src={`${pathObj?.s3ImagePath}/wishlist-icon${wishlistStatus[productDetails?.id] ? '-red' : ''}.svg`} // Check status from wishlistStatus state
                            alt="Wishlist Icon"
                            onClick={() => handleWishlistToggle(productDetails?.id)}
                            style={{ cursor: 'pointer' }}
                          />
                        </div>
                      )}
                    </div>

                    <div className="price_rating">

                      {token && (
                        <>
                          <div className="price">
                            {formatPriceWithBreakdown({
                              currencySymbol,
                              csprice: productDetails?.Csprice,
                              priceBreakdowns: productDetails?.PricesBreakdown,
                              minProductPrice: productDetails?.MinProductPrice,
                              mainProductPrice: productDetails?.MainProductPrice
                            })}
                          </div>
                          <div className="prd_rating">
                            {[1, 2, 3, 4, 5].map((rating) => {
                              const isFullStar = rating <= Math.floor(productDetails?.rating); // Check for full stars
                              const isHalfStar = rating > Math.floor(productDetails?.rating) && rating < Math.ceil(productDetails?.rating); // Check for half star
                              return (
                                <img
                                  key={rating}
                                  src={isFullStar ? `${pathObj?.s3ImagePath}/rating-icon.svg` : isHalfStar ? `${pathObj?.s3ImagePath}/half-rating-icon.svg` : `${pathObj?.s3ImagePath}/empty-rating-icon.svg`}
                                  alt={`${rating} stars`}
                                  onClick={() => {
                                    handleRatingChange(productDetails?.id, rating);
                                  }}
                                />
                              );
                            })}
                          </div>
                        </>
                      )}
                    </div>
                    {productDescription && <div className="prd_details">
                      <h4>Description</h4>
                      <ul>
                        <li>
                          <span>{productDescription ? productDescription : ''} </span>
                        </li>
                      </ul>
                    </div>}

                    <div className="prd_details">
                      {attributesListDetails?.length > 0 && <h4>Product Details</h4>}
                      <ul>
                        {attributesListDetails.map(([key, attribute]) => {
                          return (
                            <li key={attribute?.filter_label}>
                              <span>{attribute?.filter_label}</span>
                              <span>{attribute?.filter_label_data.join(', ')}</span>
                            </li>
                          )
                        })}
                      </ul>
                    </div>
                    {token ? (
                      <>
                        <div className="add_qty">
                          <div className="qty_plusminus"
                            onClick={() => togglePriceDropdown(productDetails?.ItemCode)}
                            style={{ cursor: "pointer" }}>
                            <button
                              type="button"
                              data-type="minus"
                              onClick={() =>
                                handleQuantityChange(productDetails.ItemCode, "minus")
                              }
                            >
                              <img src={`${pathObj?.s3ImagePath}/minus-icon.svg`} alt="" />
                            </button>
                            <input
                              type="text"
                              value={quantities[productDetails?.ItemCode] || 1}
                              onChange={(e) => handleQuantityChange(productDetails.ItemCode, "input", e.target.value)}
                              onFocus={(e) => e.target.select()} // Select entire value on focus
                              onKeyDown={(e) => {
                                if (e.key === '-' || e.key === 'e') {
                                  e.preventDefault(); // Prevent entering minus, plus, and exponential (e) symbols
                                }
                              }}
                            />
                            <button
                              type="button"
                              data-type="plus"
                              onClick={() => handleQuantityChange(productDetails?.ItemCode, "plus")}
                            >
                              <img
                                src={`${pathObj?.s3ImagePath}/plus-icon.svg`}
                                alt=""
                              />
                            </button>
                          </div>
                          <div className="add_btn">
                            <a
                              // href="#"
                              className="button2"
                              onClick={() => handleAddToCart(productDetails, currentPrice)}
                            >
                              Add
                            </a>
                          </div>
                        </div>
                        <div
                          className="price_dropdow"
                          style={{
                            display:
                              priceDropdownVisible[productDetails?.ItemCode] &&
                                productDetails?.PricesBreakdown?.length > 0
                                ? "block"
                                : "block",
                          }}
                        >
                          <div className="more_qty">
                            {productDetails?.PricesBreakdown?.map((priceBreakdown, index) => {
                              return (
                                <div
                                  className="more_qty_row"
                                  key={priceBreakdown.id}
                                  onClick={() =>
                                    handlePriceBreakdownClick(
                                      productDetails?.ItemCode,
                                      priceBreakdown?.Quantity,
                                      priceBreakdown?.id,
                                      priceBreakdown?.SpecialPrice // Pass the price here
                                    )
                                  }
                                  // onClick={() => handlePriceBreakdownClick(productDetails?.ItemCode, priceBreakdown?.Quantity, priceBreakdown?.id)}
                                  style={{ cursor: "pointer" }}
                                >
                                  <label>
                                    {priceBreakdown?.Quantity}qty
                                  </label>
                                  <span>
                                    {currencySymbol}{UpdatedDecimalDigits(priceBreakdown?.SpecialPrice)}
                                  </span>
                                </div>
                              )
                            })}
                          </div>
                        </div>

                      </>
                    ) : (
                      <>
                        <br />
                        <Link to="/login">
                          <input className="button4" type="submit" value=" Login to see price" />
                        </Link>
                      </>
                    )}

                  </div>

                </div>
                <AlternativeRelativeProducts isGroupProduct={ false } />
              </div>

            </div>

          </div>

          {/* Image Modal with Zoom */}
          {showModal && (
            <div 
              className="image-modal-overlay"
              onClick={handleModalClose}
              onKeyDown={handleModalKeyPress}
              tabIndex={0}
              style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                backgroundColor: 'rgba(0, 0, 0, 0.9)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                zIndex: 9999,
                outline: 'none',
              }}
            >
              <div 
                className="modal-content"
                onClick={(e) => e.stopPropagation()}
                style={{
                  position: 'relative',
                  maxWidth: '95%',
                  maxHeight: '95%',
                  backgroundColor: 'white',
                  borderRadius: '8px',
                  padding: '20px',
                  boxShadow: '0 4px 20px rgba(0,0,0,0.3)',
                  display: 'flex',
                  flexDirection: isMobile ? 'column' : 'row',
                  alignItems: 'flex-start',
                  gap: '20px'
                }}
              >
                {/* Close Button */}
                <button
                  onClick={handleModalClose}
                  style={{
                    position: 'absolute',
                    top: '10px',
                    right: '15px',
                    background: 'none',
                    border: 'none',
                    fontSize: '24px',
                    cursor: 'pointer',
                    zIndex: 10000,
                    color: '#333',
                    fontWeight: 'bold',
                  }}
                >
                  ×
                </button>

                {/* Left Side - Main Image */}
                <div className="modal-image-section" style={{
                  flex: isMobile ? '1' : '2',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center'
                }}>
                  {/* Image Counter */}
                  <div style={{
                    marginBottom: '15px',
                    color: '#666',
                    fontSize: '14px',
                    fontWeight: '500',
                  }}>
                    {modalImageIndex + 1} / {allModalImages.length}
                  </div>

                  {/* Main Image with Zoom */}
                  <div style={{ 
                    position: 'relative', 
                    display: 'flex', 
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '100%',
                    maxHeight: isMobile ? '50vh' : '60vh',
                    minHeight: isMobile ? '250px' : '400px',
                  }}>
                  {/* Previous Button */}
                  {allModalImages.length > 1 && (
                    <button
                      onClick={handleModalPrevious}
                      style={{
                        position: 'absolute',
                        left: '-20px',
                        top: '50%',
                        transform: 'translateY(-50%)',
                        background: 'rgba(0,0,0,0.5)',
                        color: 'white',
                        border: 'none',
                        borderRadius: '50%',
                        width: '40px',
                        height: '40px',
                        cursor: 'pointer',
                        fontSize: '18px',
                        zIndex: 10001,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                      }}
                    >
                      ‹
                    </button>
                  )}

                  <Zoom
                    zoomMargin={20}
                    overlayBgColorEnd="rgba(0, 0, 0, 0.95)"
                    overlayBgColorStart="rgba(0, 0, 0, 0.95)"
                  >
                    <img
                      src={modalImage}
                      alt={`Product Image ${modalImageIndex + 1}`}
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = `${pathObj?.s3ImagePath}/no-image.jpg`;
                      }}
                      style={{
                        maxWidth: '100%',
                        maxHeight: '60vh',
                        width: 'auto',
                        height: 'auto',
                        objectFit: 'contain',
                        cursor: 'zoom-in',
                        display: 'block',
                      }}
                    />
                  </Zoom>

                  {/* Next Button */}
                  {allModalImages.length > 1 && (
                    <button
                      onClick={handleModalNext}
                      style={{
                        position: 'absolute',
                        right: '-20px',
                        top: '50%',
                        transform: 'translateY(-50%)',
                        background: 'rgba(0,0,0,0.5)',
                        color: 'white',
                        border: 'none',
                        borderRadius: '50%',
                        width: '40px',
                        height: '40px',
                        cursor: 'pointer',
                        fontSize: '18px',
                        zIndex: 10001,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                      }}
                    >
                      ›
                    </button>
                  )}
                </div>

                {/* Bottom Thumbnail Navigation for mobile */}
                {isMobile && allModalImages.length > 1 && (
                  <div style={{
                    display: 'flex',
                    gap: '10px',
                    marginTop: '15px',
                    flexWrap: 'wrap',
                    justifyContent: 'center',
                    maxWidth: '100%',
                    overflowX: 'auto',
                  }}>
                    {allModalImages.map((image, index) => (
                      <img
                        key={index}
                        src={image}
                        alt={`Thumbnail ${index + 1}`}
                        onClick={() => {
                          setModalImageIndex(index);
                          setModalImage(image);
                        }}
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = `${pathObj?.s3ImagePath}/no-image.jpg`;
                        }}
                        style={{
                          width: '50px',
                          height: '50px',
                          objectFit: 'cover',
                          borderRadius: '4px',
                          cursor: 'pointer',
                          border: index === modalImageIndex ? '2px solid #FEB41D' : '2px solid transparent',
                          opacity: index === modalImageIndex ? 1 : 0.6,
                          transition: 'all 0.2s ease',
                        }}
                      />
                    ))}
                  </div>
                )}
                </div>

                {/* Right Side - Product Info & Image Titles List (Desktop Only) */}
                {!isMobile && (
                  <div className="modal-titles-section" style={{
                    flex: '1',
                    minWidth: '280px',
                    maxWidth: '350px',
                    maxHeight: '70vh',
                    overflowY: 'auto',
                    paddingLeft: '20px',
                    borderLeft: '1px solid #e0e0e0'
                  }}>
                    {/* Product Title Section */}
                    <div className="modal-product-info" style={{
                      marginBottom: '25px',
                      paddingBottom: '20px',
                      borderBottom: '1px solid #e0e0e0'
                    }}>
                      <h2 style={{
                        margin: '0 0 8px 0',
                        fontSize: '20px',
                        fontWeight: '700',
                        color: '#333',
                        lineHeight: '1.3'
                      }}>
                        {productDetails?.ItemCode} 
                      </h2>
                      <p style={{
                        margin: '0 0 12px 0',
                        fontSize: '16px',
                        fontWeight: '500',
                        color: '#555',
                        lineHeight: '1.4'
                      }}>
                        {productDetails?.U_V33_WebProductName}
                      </p>
                      {/* Stock Status */}
                      <div style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        padding: '4px 12px',
                        borderRadius: '20px',
                        fontSize: '12px',
                        fontWeight: '500',
                        backgroundColor: productDetails?.QuantityOnStock ? '#d4edda' : '#f8d7da',
                        color: productDetails?.QuantityOnStock ? '#155724' : '#721c24',
                        border: `1px solid ${productDetails?.QuantityOnStock ? '#c3e6cb' : '#f5c6cb'}`
                      }}>
                        <span style={{
                          width: '6px',
                          height: '6px',
                          borderRadius: '50%',
                          backgroundColor: productDetails?.QuantityOnStock ? '#28a745' : '#dc3545',
                          marginRight: '6px'
                        }}></span>
                        {productDetails?.QuantityOnStock ? 'In Stock' : 'Currently not available'}
                      </div>
                    </div>

                    {/* Images Section Header */}
                    <h3 style={{
                      margin: '0 0 15px 0',
                      fontSize: '18px',
                      fontWeight: '600',
                      color: '#333',
                      borderBottom: '2px solid #FEB41D',
                      paddingBottom: '8px'
                    }}>
                      Product Images ({allModalImages.length})
                    </h3>
                    
                    <div className="image-titles-list">
                      {allModalImages.map((image, index) => {
                        // Generate title based on image type
                        let imageTitle = '';
                        let imageType = '';
                        
                        if (imageStatus['Picture'] && imageStatus['Picture'].includes(image)) {
                          const pictureIndex = imageStatus['Picture'].indexOf(image);
                          imageTitle = `Product View ${pictureIndex + 1}`;
                          imageType = 'Product Image';
                        } else if (imageStatus['vectorPicture'] && imageStatus['vectorPicture'] === image) {
                          imageTitle = 'Technical Drawing';
                          imageType = 'Vector Image';
                        }
                        
                        return (
                          <div
                            key={index}
                            onClick={() => {
                              setModalImageIndex(index);
                              setModalImage(image);
                            }}
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              padding: '12px',
                              marginBottom: '8px',
                              borderRadius: '8px',
                              cursor: 'pointer',
                              backgroundColor: index === modalImageIndex ? '#FEB41D15' : '#f8f9fa',
                              border: index === modalImageIndex ? '2px solid #FEB41D' : '2px solid transparent',
                              transition: 'all 0.2s ease',
                              boxShadow: index === modalImageIndex ? '0 2px 8px rgba(254, 180, 29, 0.3)' : 'none'
                            }}
                            onMouseEnter={(e) => {
                              if (index !== modalImageIndex) {
                                e.target.style.backgroundColor = '#e9ecef';
                              }
                            }}
                            onMouseLeave={(e) => {
                              if (index !== modalImageIndex) {
                                e.target.style.backgroundColor = '#f8f9fa';
                              }
                            }}
                          >
                            <img
                              src={image}
                              alt={imageTitle}
                              style={{
                                width: '50px',
                                height: '50px',
                                objectFit: 'cover',
                                borderRadius: '6px',
                                marginRight: '12px',
                                border: '1px solid #dee2e6'
                              }}
                              onError={(e) => {
                                e.target.onerror = null;
                                e.target.src = `${pathObj?.s3ImagePath}/no-image.jpg`;
                              }}
                            />
                            <div>
                              <div style={{
                                fontWeight: '500',
                                fontSize: '14px',
                                color: '#333',
                                marginBottom: '2px'
                              }}>
                                {/* {imageTitle} */}
                              </div>
                              <div style={{
                                fontSize: '12px',
                                color: '#666',
                                fontStyle: 'italic'
                              }}>
                                {/* {imageType} */}
                              </div>
                            </div>
                            {index === modalImageIndex && (
                              <div style={{
                                marginLeft: 'auto',
                                width: '8px',
                                height: '8px',
                                backgroundColor: '#FEB41D',
                                borderRadius: '50%'
                              }}/>
                            )}
                          </div>
                        );
                      })}
                    </div>
                  </div>
                )}
              </div>
            </div>
          )}
        </>
      )}
    </>
  )
}

export default ProductDetails
